import { shiftTimezone } from '@any-ui-react/dates';
import dayjs from 'dayjs';

import { environmentStore } from '../states';

import { reportAppError } from './error.utils';

export class TimezoneUtils {
  static readonly DEFAULT = 'Asia/Tokyo';

  static setTimezone(timeZone: string) {
    if (TimezoneUtils.isValidTimeZone(timeZone)) {
      environmentStore.getState().setTimezone(timeZone);
    }
  }

  static isValidTimeZone(timeZone: string) {
    if (!timeZone) {
      return false;
    }

    try {
      Intl.DateTimeFormat(undefined, { timeZone });
      return true;
    } catch (e) {
      reportAppError(new Error('Error while checking timeZone', { cause: e }));
      return false;
    }
  }

  static toPreferredTimezone(date: Date | string | number, timezone?: string) {
    if (!date || !dayjs(new Date(date)).isValid()) {
      console.error("Couldn't convert to preferred timezone because the date is invalid");
      return new Date();
    }
    return shiftTimezone('add', new Date(date), timezone);
  }

  static getCurrentTimezone() {
    return environmentStore.getState().currentTimezone;
  }

  static getLocalTimezone() {
    if (Intl && Intl.DateTimeFormat) {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } else {
      return TimezoneUtils.DEFAULT;
    }
  }
}
